export class AnimQueue {
  constructor() {
    this.fns = [];
  }

  add(fn) {
    this.fns.push(fn);
  }

  tick(dt) {
    this.fns = this.fns.filter((fn) => fn(dt));
  }

  get active() {
    return this.fns.length > 0;
  }

  get count() {
    return this.fns.length;
  }

  clear() {
    this.fns = [];
  }
}
